var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25516_37453)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22156 11.677C3.67208 11.677 2.41597 12.9331 2.41597 14.4826C2.41597 16.032 3.67208 17.2881 5.22156 17.2881C6.77105 17.2881 8.02716 16.032 8.02716 14.4826C8.02716 12.9331 6.77105 11.677 5.22156 11.677ZM5.22156 9.87695C2.67796 9.87695 0.615967 11.9389 0.615967 14.4826C0.615967 17.0262 2.67796 19.0881 5.22156 19.0881C7.76516 19.0881 9.82716 17.0262 9.82716 14.4826C9.82716 11.9389 7.76516 9.87695 5.22156 9.87695Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6984 11.677C17.1489 11.677 15.8928 12.9331 15.8928 14.4826C15.8928 16.032 17.1489 17.2881 18.6984 17.2881C20.2479 17.2881 21.504 16.032 21.504 14.4826C21.504 12.9331 20.2479 11.677 18.6984 11.677ZM18.6984 9.87695C16.1548 9.87695 14.0928 11.9389 14.0928 14.4826C14.0928 17.0262 16.1548 19.0881 18.6984 19.0881C21.242 19.0881 23.304 17.0262 23.304 14.4826C23.304 11.9389 21.242 9.87695 18.6984 9.87695Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71198 5.99316C9.17689 5.99316 8.70114 6.33376 8.52868 6.8403L8.45935 7.04394H14.1898L14.5756 5.98618C14.7175 5.59704 15.148 5.39664 15.5371 5.53857C15.9263 5.68049 16.1267 6.11101 15.9848 6.50015L15.7559 7.12758C15.8835 7.1935 15.9918 7.2958 16.0648 7.42524L19.5423 13.5852C19.6734 13.8174 19.6713 14.1018 19.5369 14.332C19.4025 14.5623 19.1559 14.7039 18.8892 14.7039H12.4679C12.2231 14.7039 11.9937 14.5845 11.8534 14.3839C11.713 14.1833 11.6794 13.9269 11.7633 13.6969L13.6427 8.54394H7.9623L6.19258 14.1786C6.06846 14.5738 5.64749 14.7936 5.25231 14.6694C4.85712 14.5453 4.63738 14.1244 4.7615 13.7292L6.53758 8.07423C6.54411 8.02893 6.55489 7.98357 6.57018 7.93867L6.70127 7.55364C6.70162 7.5526 6.70197 7.55157 6.70233 7.55053L7.10872 6.35686C7.48812 5.24247 8.53477 4.49316 9.71198 4.49316H9.78016C10.1944 4.49316 10.5302 4.82895 10.5302 5.24316C10.5302 5.65738 10.1944 5.99316 9.78016 5.99316H9.71198ZM15.1351 8.82962L13.5397 13.2039H17.6046L15.1351 8.82962Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3427 5.24316C13.3427 4.82895 13.6785 4.49316 14.0927 4.49316L17.0927 4.49316C17.5069 4.49316 17.8427 4.82895 17.8427 5.24316C17.8427 5.65738 17.5069 5.99316 17.0927 5.99316L14.0927 5.99316C13.6785 5.99316 13.3427 5.65738 13.3427 5.24316Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95922 7.72511C7.27015 7.45144 7.74406 7.48164 8.01773 7.79257L12.8119 13.2393C13.0856 13.5503 13.0554 14.0242 12.7445 14.2978C12.4335 14.5715 11.9596 14.5413 11.6859 14.2304L6.89177 8.78363C6.6181 8.4727 6.64829 7.99879 6.95922 7.72511Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25516_37453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.e8b823ab3ba6454325d7f98410eba4b5.svg";
export { ForwardRef as ReactComponent };